import { Button, CircularProgress, type ButtonProps, type SxProps, type Theme } from '@mui/material';
import type { ReactNode } from 'react';
import { mergeSx } from '../../../utils/styles';

export type FormSubmitButtonPresentation = {
  disabled?: boolean;
  fullWidth?: boolean;
  label?: ReactNode;
  sx?: SxProps<Theme>;
  testId?: string;
  variant?: ButtonProps['variant'];
};

type FormSubmitButtonProps = FormSubmitButtonPresentation & {
  isSubmitting?: boolean;
  title: ReactNode;
};

const defaultStyles = {
  backgroundColor: 'primary.main',
  '&:hover': {
    backgroundColor: 'primary.700',
  },
  borderRadius: 2,
  height: 60,
  textTransform: 'uppercase',
};

const FormSubmitButton = ({
  disabled,
  fullWidth = true,
  isSubmitting = false,
  label,
  sx,
  testId,
  title,
  variant = 'contained',
}: FormSubmitButtonProps) => {
  return (
    <Button
      type='submit'
      variant={variant}
      fullWidth={fullWidth}
      disabled={isSubmitting || disabled}
      data-testid={testId}
      sx={mergeSx(defaultStyles, sx)}
    >
      {isSubmitting ? <CircularProgress size={20} sx={{ color: 'neutral.25' }} /> : (label ?? title)}
    </Button>
  );
};

export default FormSubmitButton;
